// src/admin/blog/BlogForm.jsx
import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft, Image as ImageIcon } from "lucide-react";
import useAdminStore from "../store/useAdminStore";
import styles from "../projects/ProjectsAdmin.module.css"; // Reutilizamos el mismo CSS

export default function BlogForm({ mode = "new" }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const { blogPosts, addPost, updatePost } = useAdminStore();
  const post = blogPosts?.find(p => p.id.toString() === id);

  const [form, setForm] = useState({
    title: "",
    excerpt: "",
    content: "",
    image: "",
    author: "Ezequiel Bamio",
    date: new Date().toLocaleDateString("es-AR"),
    readTime: "10 min"
  });

  useEffect(() => {
    if (mode === "edit" && post) {
      setForm(post);
    }
  }, [mode, post]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (mode === "new") {
      addPost({ ...form, id: Date.now() });
    } else {
      updatePost(id, form);
    }
    navigate("/admin/blog");
  };

  return (
    <div className={styles.formContainer}>
      <button onClick={() => navigate(-1)} className={styles.formBackBtn}>
        <ArrowLeft size={22} />
        Volver
      </button>

      <motion.h1 className={styles.formTitle}>
        {mode === "new" ? "Nuevo Post" : "Editar Post"}
      </motion.h1>

      <form onSubmit={handleSubmit} className={styles.form}>
        <div className={styles.inputGroup}>
          <label>Título</label>
          <input
            type="text"
            value={form.title}
            onChange={(e) => setForm({ ...form, title: e.target.value })}
            required
          />
        </div>

        <div className={styles.inputGroup}>
          <label>Extracto (para la tarjeta)</label>
          <textarea
            rows={3}
            value={form.excerpt}
            onChange={(e) => setForm({ ...form, excerpt: e.target.value })}
            required
          />
        </div>

        <div className={styles.inputGroup}>
          <label>Imagen de portada (URL)</label>
          <div className={styles.inputWrapper}>
            <ImageIcon size={22} className={styles.inputIcon} />
            <input
              type="url"
              value={form.image}
              onChange={(e) => setForm({ ...form, image: e.target.value })}
              placeholder="https://i.imgur.com/..."
            />
          </div>
        </div>

        <div className={styles.inputGroup}>
          <label>Contenido completo (HTML o Markdown)</label>
          <textarea
            rows={20}
            value={form.content}
            onChange={(e) => setForm({ ...form, content: e.target.value })}
            required
            className={styles.textarea}
          />
        </div>

        <div className={styles.linksGrid}>
          <div className={styles.inputGroup}>
            <label>Autor</label>
            <input
              type="text"
              value={form.author}
              onChange={(e) => setForm({ ...form, author: e.target.value })}
              required
            />
          </div>
          <div className={styles.inputGroup}>
            <label>Tiempo de lectura</label>
            <input
              type="text"
              value={form.readTime}
              onChange={(e) => setForm({ ...form, readTime: e.target.value })}
              placeholder="10 min"
            />
          </div>
        </div>

        <motion.button
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
          type="submit"
          className={styles.submitBtn}
        >
          {mode === "new" ? "Publicar Post" : "Guardar Cambios"}
        </motion.button>
      </form>
    </div>
  );
}